import { render, staticRenderFns } from "./ManualClearingModal.vue?vue&type=template&id=20021015&scoped=true&"
import script from "./ManualClearingModal.vue?vue&type=script&lang=js&"
export * from "./ManualClearingModal.vue?vue&type=script&lang=js&"
import style0 from "./ManualClearingModal.vue?vue&type=style&index=0&id=20021015&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20021015",
  null
  
)

export default component.exports